import { TeamsComponent } from '../pages/portfolio/projects/teams/teams.component';
import { MonopolistComponent } from '../pages/portfolio/projects/monopolist/monopolist.component';
import { ArticleuiComponent } from '../pages/portfolio/projects/articleui/articleui.component';
import { FiveHundredPxComponent } from '../pages/portfolio/projects/500px/500px.component';
import { QuflipComponent } from '../pages/portfolio/projects/quflip/quflip.component';
import { SpectreComponent } from '../pages/portfolio/projects/spectre/spectre.component';
import { BasicjaneComponent } from '../pages/portfolio/projects/basicjane/basicjane.component';
import { NovoComponent } from '../pages/portfolio/projects/novo/novo.component';
import { TomfrenchComponent } from '../pages/portfolio/projects/tomfrench/tomfrench.component';

interface Icon {
  url: string;
  size: string;
  position: string;
}

export enum Skills {
  ux = 'UX',
  ui = 'UI',
  uxengineering = 'UX Engineering',
  develop = 'Development',
}
export interface Cover {
  background?: string;
  icon?: Icon;
}
export interface IProject {
  id: string;
  title: string;
  link: string;
  skills: string[];
  year: number;
  cover?: Cover;
  views?: number;
  likes?: number;
  award?: string;
  request?: string;
  featured: number;
  component: any;
  [key: string]: any;
}

const getImageUrl = (image: string) => {
  return 'url(../assets/img/covers/' + image + ')';
};

export const Projects: IProject[] = [
  {
    id: 'teams',
    title: 'Microsoft Teams',
    link: 'https://products.office.com/en-us/microsoft-teams/',
    skills: [Skills.uxengineering],
    year: 2018,
    request: 'Request required',
    cover: {
      background:
        'radial-gradient(farthest-side at -10% -20%, #888AD6 0%, #262474 150%)',
      icon: {
        url: getImageUrl('icons/teams.svg'),
        size: '175px 180px',
        position: '25px 67%',
      },
    },
    component: TeamsComponent,
    featured: 0,
  },
  {
    id: 'mn',
    title: 'Monopolist',
    link: 'https://www.behance.net/gallery/35191125/Monopolist-Mac-OSX-Game',
    skills: [Skills.ux, Skills.ui],
    year: 2015,
    cover: {
      background: getImageUrl('monopolist.jpg'),
      icon: {
        url: getImageUrl('icons/mn.png'),
        size: '206px 203px',
        position: '-5px 58%',
      },
    },
    views: 2166,
    likes: 392,
    award:
      '<a class="rf-ribbon" href="https://www.behance.net/galleries/11/Game-Design"><im' +
      'g src="https://a5.behance.net/5686b69c3729dcfa51c4f52263668b5742397fa1/img/share' +
      'd_icons/png/1x/ribbons/game-design.png?cb=264615658" srcset="https://a5.behance.' +
      'net/5686b69c3729dcfa51c4f52263668b5742397fa1/img/shared_icons/png/1x/ribbons/gam' +
      'e-design.png?cb=264615658, https://a5.behance.net/5686b69c3729dcfa51c4f52263668b' +
      '5742397fa1/img/shared_icons/png/2x/ribbons/game-design.png?cb=264615658 2x" titl' +
      'e="" class="rf-ribbon__svg"></a>',
    component: MonopolistComponent,
    featured: 1,
  },
  {
    id: 'article-ui',
    title: 'Article UI',
    link: 'https://www.behance.net/gallery/41871883/Article-UI',
    skills: [Skills.ui, Skills.develop],
    year: 2016,
    cover: {
      background: getImageUrl('articleui.jpg'),
      icon: {
        url: getImageUrl('icons/articleui.svg'),
        size: '314px 322px',
        position: '5px 33px',
      },
    },
    views: 18532,
    likes: 2369,
    component: ArticleuiComponent,
    featured: 2,
  },
  {
    title: '500px:Store',
    link: 'https://dribbble.com/shots/3556996-500px-Store',
    id: 'px500',
    skills: [Skills.uxengineering],
    year: 2017,
    cover: {
      icon: {
        url: getImageUrl('icons/500.png'),
        size: '269px 307px',
        position: '-23px 71%',
      },
    },
    views: 1125,
    likes: 78,
    component: FiveHundredPxComponent,
    featured: 3,
  },
  {
    title: 'Quflip',
    link: 'https://dribbble.com/shots/3562238-QUFLIP',
    id: 'quflip',
    skills: [Skills.ux, Skills.ui],
    year: 2017,
    cover: {
      background: getImageUrl('quflip.jpg'),
      icon: {
        url: getImageUrl('icons/quflip.png'),
        size: '254px 180px',
        position: '-23px 63%',
      },
    },
    views: 370,
    likes: 25,
    component: QuflipComponent,
    featured: 4,
  },
  {
    title: 'The Spectre',
    link: 'https://www.behance.net/gallery/41773187/The-Spectre-Free-Icon-Set',
    id: 'spectre',
    skills: [Skills.ux, Skills.ui, Skills.develop],
    year: 2016,
    cover: {
      background: getImageUrl('spectre.jpg'),
    },
    views: 31794,
    likes: 3094,
    award:
      '<a href="https://www.behance.net/galleries/8/Interaction"><img src="https://a5.b' +
      'ehance.net/5686b69c3729dcfa51c4f52263668b5742397fa1/img/shared_icons/png/1x/ribb' +
      'ons/interaction.png?cb=264615658" srcset="https://a5.behance.net/5686b69c3729dcf' +
      'a51c4f52263668b5742397fa1/img/shared_icons/png/1x/ribbons/interaction.png?cb=264' +
      '615658, https://a5.behance.net/5686b69c3729dcfa51c4f52263668b5742397fa1/img/shar' +
      'ed_icons/png/2x/ribbons/interaction.png?cb=264615658 2x" title="" class="rf-ribb' +
      'on__svg"></a>',
    component: SpectreComponent,
    featured: 5,
  },
  {
    title: 'BasicJane',
    link: 'https://basicjane.com',
    id: 'bj',
    skills: [Skills.ui, Skills.develop],
    year: 2017,
    cover: {
      icon: {
        url: getImageUrl('icons/bj.png'),
        size: '242px 180px',
        position: '4px 61%',
      },
    },
    views: 9236,
    likes: 1291,
    component: BasicjaneComponent,
    featured: 6,
  },
  {
    title: 'Real Estate',
    link: 'https://www.behance.net/gallery/33663230/Real-Estate-in-Moscow',
    id: 'novo',
    skills: [Skills.ux, Skills.ui],
    year: 2015,
    cover: {
      background: getImageUrl('novostroyker.jpg'),
      icon: {
        url: getImageUrl('icons/novo.png'),
        size: '279px 211px',
        position: '1px 68%',
      },
    },
    views: 9236,
    likes: 1291,
    component: NovoComponent,
    featured: 7,
  },
  {
    title: 'Tom French',
    link: 'https://dribbble.com/shots/3649076-Tom-French',
    id: 'french',
    skills: [Skills.uxengineering],
    year: 2017,
    cover: {
      icon: {
        url: getImageUrl('icons/tom.png'),
        size: '216px 220px',
        position: '14px 62%',
      },
    },
    views: 625,
    likes: 52,
    component: TomfrenchComponent,
    featured: 8,
  },
  // {   title: 'Seattle City Light',   link:
  // 'https://dribbble.com/shots/3559612-Seattle-City-Light-Dashboard',   class:
  // 'citylight',   skills: ['UX', 'UI'],   year: 2017,   views: 721,   likes: 48,
  // }, {   title: 'NFL Draft App',   link:
  // 'https://dribbble.com/shots/2626035-NFL-Draft-App',   class: 'nfl',   skills:
  // ['UX', 'UI'],   year: 2017,   views: 2246,   likes: 74, },
];

export const ProjectsList: IProject[] = [...Projects];



// WEBPACK FOOTER //
// ./src/app/_data/projects.ts